<template>
  <van-overlay :show="show" :z-index="13" @click="onClick">
    <div class="wrapper" @click.stop v-if="tagDetail">
      <div class="block" :style="{ 'background-image': 'url(' + bgImg + ')' }">
        <div class="block-title">{{ tagDetail.title }}</div>
        <div class="block-content" v-html="tagDetail.explain"></div>
      </div>
    </div>
  </van-overlay>
</template>

<script>
import { Overlay } from 'vant'
import { preloadImage } from 'utils/tool.js'

export default {
  components: {
    [Overlay.name]: Overlay
  },
  props: {
    tagDetail: [Object, null]
  },
  computed: {
    show() {
      return !!this.tagDetail
    },
    bgImg() {
      return require('images/platform/homepage/tag-detail-bg.png')
    }
  },
  mounted() {
    // 预加载背景图
    preloadImage(this.bgImg)
  },
  methods: {
    onClick() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~lib/scss/functions.scss';

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate3d(-50%, -50%, 0);
  min-height: 276px;
}

.block {
  width: 560px;
  background-color: #fff;
  border-radius: 30px;
  background-repeat: no-repeat;
  background-size: 100% auto;
  background-position: top left;
  position: relative;
  padding: 160px 30px 30px 30px;
  .block-title {
    font-size: 32px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #ffffff;
    position: absolute;
    left: 30px;
    top: 27px;
    @include limitLine(1);
  }
  .block-content {
    font-size: 28px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #6c798c;
    line-height: 49px;
  }
}
</style>
